import { Reveal } from "./Reveal";
import { Mail, ArrowRight } from "lucide-react";

export function WantList() {
  return (
    <section id="want-list" className="relative border-y border-border/70 bg-primary text-primary-foreground py-24 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, oklch(0.98 0 0) 0, transparent 40%), radial-gradient(circle at 80% 60%, oklch(0.98 0 0) 0, transparent 45%)",
        }}
      />
      <div className="relative mx-auto max-w-5xl px-6 text-center">
        <Reveal>
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-brass">
            Want list · Mail order
          </p>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="font-display text-4xl leading-tight md:text-6xl">
            Post-1939 U.S. MNH plate blocks &amp; singles —{" "}
            <span className="italic text-brass-soft">by mail, at 20% under SCV.</span>
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="mx-auto mt-6 max-w-2xl text-primary-foreground">
            Send us your want list and we'll match it from the shelves.
            $5.00 minimum order · $1.00 shipping on small lots · shipping
            quoted for larger orders.
          </p>
        </Reveal>
        <Reveal delay={3}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <a
              href="mailto:sallyc@ix.netcom.com?subject=Want%20List"
              className="group inline-flex min-h-12 items-center gap-2 rounded-sm bg-accent px-5 py-3 text-sm font-medium text-accent-foreground shadow-[var(--shadow-stamp)] transition-transform hover:-translate-y-0.5"
            >
              <Mail className="h-4 w-4" aria-hidden="true" />
              Send a want list
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </a>
            <a
              href="https://www.ebay.com/str/carolinamountainstamps"
              target="_blank"
              rel="noreferrer noopener"
              className="inline-flex min-h-12 items-center gap-2 rounded-sm border border-primary-foreground/40 px-5 py-3 text-sm font-medium text-primary-foreground hover:bg-primary-foreground/10"
            >
              Browse eBay store
              <span className="sr-only">(opens in a new tab)</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}